/* Lista de presentes de un evento, agrupada por segmento.
 *
 * El backend devuelve los presentes ya ordenados por el orden del segmento
 * (y dentro de cada segmento, primero los reconocidos). Acá solo los agrupamos
 * visualmente con un encabezado por segmento, para facilitar el reconocimiento
 * por segmento el día del evento.
 */
import { IonItem, IonLabel } from "@ionic/react";
import { Typography } from "@material-ui/core";

interface Props {
  presentes: any[];
  requiereEvaluacion?: boolean;
}

const EventoPresentesLista: React.FC<Props> = ({ presentes, requiereEvaluacion }) => {
  if (!presentes.length) {
    return (
      <Typography variant="body2" color="textSecondary" style={{ padding: "8px 4px" }}>
        Aún no hay presentes registrados.
      </Typography>
    );
  }

  // Agrupar preservando el orden recibido (no reordenar).
  const grupos: { nombre: string; items: any[] }[] = [];
  presentes.forEach((p) => {
    const nombre = p.segmento_nombre || "Sin segmento";
    let g = grupos.find((x) => x.nombre === nombre);
    if (!g) {
      g = { nombre, items: [] };
      grupos.push(g);
    }
    g.items.push(p);
  });
  const haySegmentos = grupos.some((g) => g.nombre !== "Sin segmento");

  return (
    <>
      {grupos.map((g) => (
        <div key={g.nombre}>
          {haySegmentos && (
            <Typography
              variant="caption"
              style={{ display: "block", fontWeight: 700, color: "#1565c0", marginTop: 10, paddingLeft: 4 }}
            >
              {g.nombre} ({g.items.length})
            </Typography>
          )}
          {g.items.map((p, i) => (
            <IonItem key={`${g.nombre}-${i}`} lines="full">
              <IonLabel className="ion-text-wrap">
                {p.es_reconocido ? "★ " : ""}
                {p.nombre || p.cedula}
                {(p.acompanantes_presentes ?? 0) > 0 ? ` (+${p.acompanantes_presentes})` : ""}
                {requiereEvaluacion
                  ? p.evaluacion_completada
                    ? " · ✓ evaluó"
                    : " · evaluación pendiente"
                  : ""}
              </IonLabel>
            </IonItem>
          ))}
        </div>
      ))}
    </>
  );
};

export default EventoPresentesLista;
